import {
  Button, Loading, Table, Alert,
} from '@roo/roo';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Column } from '@roo/roo/Table';
import Empty from './Empty';
import { getJudgeGroups } from '../../assets/apis/review';
import Header from '../../components/HeaderWithoutMenu';

import './index.scss';

const noticeText = `组别状态为“待确认”时，您可检查为您分配的项目是否存在学科不匹配、利益相关、领域不相关等需要退评的情况。若存在，请及时联系huanbao@meituan.com申请退评，我们将尽快为您分配新的评审组别与项目。组别状态为“已确认”时，您可开始评审。
`;

const ReviewList = function ({ data }) {
  const history = useHistory();
  const columns: Column<any>[] = [
    {
      prop: 'groupName', label: '组别', align: 'center', width: 190,
    },
    {
      prop: 'projectConfigName', label: '项目类型', align: 'center', width: 190,
    },
    {
      prop: 'projectAmount', label: '项目数量', align: 'center', width: 190,
    },
    {
      prop: 'projectStageName', label: '阶段', align: 'center', width: 190,
    },
    {
      prop: 'groupStatus',
      label: '组别状态',
      align: 'center',
      width: 190,
      render: (text) => {
        const status = text === '已确认' ? 2 : 0;
        return text ? (
          <span className={`status status-${Number(status)}`}>{text}</span>
        ) : '-';
      },
    },
    {
      prop: 'round', label: '当前轮次', align: 'center', width: 190,
    },
    {
      prop: 'groupId',
      align: 'center',
      label: '操作',
      render: (_, item) => {
        const { groupId } = item;
        return (
          <Button
            type="brand-text"
            style={{ color: '#FF6A00' }}
            onClick={() => {
              history.push(`/review/projectList?groupId=${groupId}`);
            }}
          >
            进入项目列表
          </Button>
        );
      },
    },
  ];
  return (
    <div className="review-list">
      <p className="title"> 参与评审组别列表</p>
      {data && data.length && (
        <Alert
          className="review-list__alert_v2"
          type="warning"
          icon="roo-icon-exclamation-circle"
          title={noticeText}
        />
      )}
      <div className="review-list__group">
        <Table
          className="review-list__group__content"
          // showIndex
          border
          rowKey="groupId"
          columns={columns}
          data={data}
        />
      </div>
    </div>
  );
};

interface InitState {
  groups: object[] | null;
  loading: boolean;
}

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.getGroups();
  }

  getGroups = async () => {
    getJudgeGroups()
      .then((res) => {
        const { groups } = res;
        this.setState({ groups });
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { groups, loading } = this.state as InitState;
    return (
      <div>
        <Header plate="评审平台" />
        <div className="page-list" style={{ marginTop: 0 }}>
          <div className="warp">
            {groups
              && (groups.length === 0 ? (
                <Empty />
              ) : loading ? (
                <Loading visible backdrop fullscreen />
              ) : (
                <ReviewList data={groups} />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default List;
